module.exports = __webpack_public_path__ + "static/img/logo.d0c4ba62.svg";